import type { FaireProductEntity } from "../../entity_types/product";

export const p_6n6nde5sza: FaireProductEntity = {
  token: "p_6n6nde5sza",
  type: "product",
  name: "Merry Mahjong: Novelty Mahjong Playing Card (Set of 4)",
  brandToken: "b_m2upumjee3",
  brandName: "Mahjong & Magnolias",
  imageUrl:
    "https://cdn.faire.com/fastly/50c9160bab72d5df98d4fe4275569413e762edc1a3c9bf44ba0c6d74d3686817.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8b412cc40eb616210b76a94c6ac7baa5daabc7b43194f4f2929a049a58c5f2f2.jpeg",
    "https://cdn.faire.com/fastly/4d42c0ab316289c7d21d0bd00a9983a47aad856e4c1bbe00b61123d05b753782.png",
    "https://cdn.faire.com/fastly/4531c71120f13025238689a84bf3fcaead25659a2931759b83e1582ebaa7ee84.png",
    "https://cdn.faire.com/fastly/e36ca194bba811e09c70a78028dc48f4d5edd2d94e92e76a732fe4b7e513a456.jpeg",
  ],
  priceDollars: 24,
  description:
    "A delightful alternative to the standard National Mahjong League card.  Our cards use the same tiles and the same rules as American Mahjong but a unique legend providing a wordplay twist spelling words like Santa, Tree and even Buddy. \n\nThese matte laminated cards are sold in sets of four so everyone in your group can play.\n\nCheck on the video below to learn more.",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:48.929Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
